<script>
import {EDIT_SCHOOL} from "@/core/services/store/school-link-source/school-link-source.module";
import SchoolLinkForm from "@/view/pages/school-link-source/component/SchoolLinkForm.vue";

export default {
  name: "ModalEditSchool",
  components: {SchoolLinkForm},
  props: {
    provinces: {
      type: Array,
      default() {
        return []
      }
    },
    schoolCurrent: {
      type: Object,
      default() {
        return null
      }
    }
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("Modal_Edit_School");
    },
    resetForm() {
      this.$refs.schoolLinkForm?.resetForm();
    },
    confirmEditSchool(payload) {
      this.loading = true;
      this.$store.dispatch(EDIT_SCHOOL, {
        id: this.schoolCurrent.id,
        data: payload
      }).then(() => {
        this.closeModal();
        this.$notify({
          title: "Thành công",
          message: "Sửa trường liên kết thành công",
          type: "success"
        });
        this.$emit("refreshData")
      }).catch(() => {
        this.$notify.error({
          title: "Đã có lỗi xảy ra",
          message: "Vui lòng thử lại"
        });
      }).finally(() => {
        this.loading = false;
      })
    },
  }
}
</script>

<template>
  <b-modal id="Modal_Edit_School" title="Sửa trường liên kết" centered hide-footer ref="Modal_Edit_School"
           size="lg" @hidden="resetForm">
    <school-link-form
        ref="schoolLinkForm"
        :provinces="provinces"
        :initial-value="schoolCurrent"
        :loading="loading"
        is-edit
        submit-text="Xác nhận"
        cancel-text="Hủy"
        @submit="confirmEditSchool"
        @cancel="closeModal"
    />
  </b-modal>
</template>

<style scoped>
</style>
